import axios from 'axios';
import type { DafScopeConfig } from '../types';

export async function getScopes(appBaseUrl: string): Promise<DafScopeConfig[]> {
    const scopesConfigFilename: string = `${appBaseUrl.replace(/\/$/, '')}/scopes.json`;
    try {
        const resp = await axios.get<DafScopeConfig[]>(scopesConfigFilename);
        return resp.data;
    } catch (e) {
        throw new Error(`${e && e.response && e.response.status}`);
    }
}
